<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NGDIc3/media/FC-9789948797333.jpg?1684515201001" alt="This image is the cover for the book جزء من ممتلكاتي"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">جزء من ممتلكاتي
      </h1>
      <p class="bookDescription body article font2">
        <p>تحكي رواية "جزء من ممتلكاتي" عن أمبر ماكويني الفتاة المراهقة، التي تبحث عن قاتل والدتها برفقة لويس فانديزا الذي أخذ على عاتقه مسئوليَّة حمايتها والاهتمام بها، ليس فقط تلبيةً لوصيَّة والدتها، بل لعهد كان قد قطعه أمام بريق عدستيها المختلفتين، في اليوم الذي قبضَت أناملها الصغيرة بنصره لأول مرة. عالَم لا يحمل مِن الرحمة شيئًا وُجِد فيه فانديزا يصارع أعزلَ برفقة صاحبَيه، وبسلاح يصعب تصديقه. تلك القدرة في قراءة دواخل المرء كانت سلاحًا خارقًا، يتحكَّم به البطل ببراعة منقطِعة النَّظير، محاربًا فيه قدره، ومغترًّا تمامًا بتملُّكه لفتاته وإلى أبعد الحدود. الكاتبة الشابَّة لهذه الرواية (ليلى) حملَت لنا العديد مِن المفاجآت، وصنعَت شخصيات كثيرة تدور حولها الأحداث بترابط محكَم وسياق عبقري انتهت به الرواية إلى غير ما يمكن للقارئ أن يتوقَّع!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        ليلى
      </h2>
      
      <p class="authorDescription body article">ليلى.. عمانيَّة الجنسيَّة، حاصلة على شهادة الماجستير في المحاسبة وريادة الأعمال في جامعة بيدفود شاير بالمملكة المتحدة. تتَّسِم بخيال جامح وعشق لا حدودَ له للقلم. روايتها هذه هي أوَّل أعمالها للنشر.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?284b6669